import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, toHandlers as _toHandlers, mergeProps as _mergeProps, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { style: {"width":"100%"} }
const _hoisted_2 = {
  class: "import-steps",
  style: {"gap":"50px"}
}
const _hoisted_3 = { class: "import-step-badge" }
const _hoisted_4 = { class: "dialog-card warning" }
const _hoisted_5 = { class: "dialog-title" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "fal fa-exclamation-triangle" }, null, -1)
const _hoisted_7 = { class: "dialog-body" }
const _hoisted_8 = { class: "dialog-actions" }
const _hoisted_9 = { style: {"margin-left":"auto","display":"flex"} }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "dialog-bottom" }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "fal fa-map-marker-alt" }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_13 = {
  key: 0,
  class: "uploading-message error",
  style: {"margin-bottom":"15px"}
}
const _hoisted_14 = { class: "uploading-message-inner" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("i", { class: "fal fa-exclamation-triangle" }, null, -1)
const _hoisted_16 = {
  key: 0,
  class: "error-message"
}
const _hoisted_17 = {
  key: 1,
  class: "error-message"
}
const _hoisted_18 = {
  key: 2,
  class: "error-message"
}
const _hoisted_19 = {
  key: 3,
  class: "error-message"
}
const _hoisted_20 = {
  key: 4,
  class: "error-message"
}
const _hoisted_21 = {
  key: 1,
  style: {"display":"block","margin-bottom":"10px"}
}
const _hoisted_22 = {
  key: 2,
  class: "row",
  style: {"width":"calc(100% - 45px)"}
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-info-circle" }, null, -1)
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = ["innerHTML"]
const _hoisted_26 = { style: {"display":"flex","flex-direction":"column"} }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-info-circle" }, null, -1)
const _hoisted_28 = [
  _hoisted_27
]
const _hoisted_29 = ["innerHTML"]
const _hoisted_30 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-info-circle" }, null, -1)
const _hoisted_31 = [
  _hoisted_30
]
const _hoisted_32 = ["innerHTML"]
const _hoisted_33 = {
  key: 3,
  style: {"display":"block","margin-bottom":"10px"}
}
const _hoisted_34 = {
  key: 4,
  class: "row",
  style: {"width":"calc(100% - 45px)"}
}
const _hoisted_35 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-info-circle" }, null, -1)
const _hoisted_36 = [
  _hoisted_35
]
const _hoisted_37 = ["innerHTML"]
const _hoisted_38 = { style: {"display":"block","margin-bottom":"10px","margin-top":"10px"} }
const _hoisted_39 = {
  key: 5,
  style: {"width":"100%","margin-top":"25px","margin-bottom":"50px","overflow-x":"auto","box-shadow":"inset -9px 0px 10px -10px #000"}
}
const _hoisted_40 = {
  key: 6,
  style: {"width":"100%","height":"500px","background":"#f8fafb","border":"solid 1px #eaeaea","display":"flex","align-items":"center","justify-content":"center"}
}
const _hoisted_41 = { class: "import-dialog-actions" }
const _hoisted_42 = { key: 0 }
const _hoisted_43 = { key: 1 }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("i", {
  style: {"margin-left":"10px"},
  class: "fal fa-angle-right"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_imdex_btn = _resolveComponent("imdex-btn")!
  const _component_imdex_dialog = _resolveComponent("imdex-dialog")!
  const _component_imdex_text_field = _resolveComponent("imdex-text-field")!
  const _component_imdex_tooltip = _resolveComponent("imdex-tooltip")!
  const _component_imdex_select = _resolveComponent("imdex-select")!
  const _component_mapTable = _resolveComponent("mapTable")!
  const _component_imdex_spinner = _resolveComponent("imdex-spinner")!
  const _component_HierarchySelector = _resolveComponent("HierarchySelector")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.steps, (step, i) => {
        return (_openBlock(), _createElementBlock("div", {
          key: i,
          class: _normalizeClass(["import-step", { active: _ctx.activeFile == i }])
        }, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(i + 1), 1),
          _createTextVNode(" " + _toDisplayString(step.name), 1)
        ], 2))
      }), 128))
    ]),
    _createVNode(_component_imdex_dialog, {
      width: "500",
      value: _ctx.cancelDialog,
      "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.cancelDialog) = $event))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createTextVNode(" " + _toDisplayString(_ctx.$t("import.mapping.confirmCancel")), 1)
          ]),
          _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t("import.mapping.notSavedWarning")), 1),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_imdex_btn, {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.cancelDialog = false)),
                text: ""
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("import.mapping.notSavedCancelBtn")), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_imdex_btn, {
                style: {"margin-left":"10px"},
                onClick: _ctx.confirmCancel
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("import.mapping.notSavedOkBtn")), 1)
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ]),
          _hoisted_10
        ])
      ]),
      _: 1
    }, 8, ["value"]),
    (!_ctx.showHierarchySelector)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["import-inputs animated-fast dataset-mapping animated-fast", {
				fadeInRight: _ctx.transInNext,
				fadeOutLeft: _ctx.transOutNext,
				fadeInLeft: _ctx.transInPrev,
				fadeOutRight: _ctx.transOutPrev
			}])
        }, [
          _createElementVNode("h3", null, [
            _hoisted_11,
            _createTextVNode(" " + _toDisplayString(_ctx.steps[_ctx.activeFile].name) + " " + _toDisplayString(_ctx.$t("import.mapping.activeFileData")) + " ", 1),
            _hoisted_12
          ]),
          (_ctx.hasError)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _hoisted_15,
                  _createElementVNode("div", null, [
                    (_ctx.errors.delimiter)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                          _createElementVNode("h4", null, _toDisplayString(_ctx.$t("import.mapping.invalidDelim")), 1),
                          _createElementVNode("span", null, _toDisplayString(_ctx.$t("import.mapping.invalidDelimExpl")), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.errors.nanSymbol)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                          _createElementVNode("h4", null, _toDisplayString(_ctx.$t("import.mapping.invalidNaN")), 1),
                          _createElementVNode("span", null, _toDisplayString(_ctx.$t("import.mapping.invalidNaNExpl")), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.errors.variables)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                          _createElementVNode("h4", null, _toDisplayString(_ctx.$t("import.mapping.missingMap")), 1),
                          _createElementVNode("span", null, _toDisplayString(_ctx.$t("import.mapping.missingMapExpl")), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.noVariablesSelected)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                          _createElementVNode("h4", null, _toDisplayString(_ctx.$t("import.mapping.noPropertiesSelected")), 1),
                          _createElementVNode("span", null, _toDisplayString(_ctx.$t("import.mapping.noPropertiesSelectedExpl")), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.errors.dataStartRow)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                          _createElementVNode("h4", null, _toDisplayString(_ctx.$t("import.mapping.invalidDataStarts")), 1),
                          _createElementVNode("span", null, _toDisplayString(_ctx.$t("import.mapping.invalidDataStartsExpl")), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (!_ctx.skipMapping && !_ctx.isGasFile)
            ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(_ctx.$t("import.mapping.csvConfigTitle")), 1))
            : _createCommentVNode("", true),
          (!_ctx.skipMapping && !_ctx.isGasFile && !(_ctx.fileExtension == 'dm'))
            ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                _createVNode(_component_imdex_text_field, {
                  disabled: _ctx.loading,
                  onChange: _ctx.refreshMetadata,
                  value: _ctx.delimiter,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.delimiter) = $event)),
                  error: _ctx.errors.delimiter && _ctx.verified,
                  label: _ctx.$t(`import.mapping.delimLabel`),
                  style: {"margin-bottom":"10px"}
                }, null, 8, ["disabled", "onChange", "value", "error", "label"]),
                _createVNode(_component_imdex_tooltip, { nudgeY: -10 }, {
                  activator: _withCtx((on) => [
                    _createElementVNode("div", _mergeProps(_toHandlers(on), { class: "input-info" }), _hoisted_24, 16)
                  ]),
                  tooltip: _withCtx(() => [
                    _createElementVNode("span", {
                      innerHTML: _ctx.$t(`import.mapping.delimTooltip`)
                    }, null, 8, _hoisted_25)
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_26, [
                  _createVNode(_component_imdex_text_field, {
                    disabled: _ctx.loading,
                    onChange: _ctx.refreshMetadata,
                    value: _ctx.nanSymbol,
                    "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.nanSymbol) = $event)),
                    error: _ctx.errors.nanSymbol && _ctx.verified,
                    label: _ctx.$t(`import.mapping.nanLabel`),
                    style: {"margin-bottom":"10px"}
                  }, null, 8, ["disabled", "onChange", "value", "error", "label"])
                ]),
                _createVNode(_component_imdex_tooltip, { nudgeY: -10 }, {
                  activator: _withCtx((on) => [
                    _createElementVNode("div", _mergeProps(_toHandlers(on), { class: "input-info" }), _hoisted_28, 16)
                  ]),
                  tooltip: _withCtx(() => [
                    _createElementVNode("span", {
                      innerHTML: _ctx.$t(`import.mapping.nanTooltip`)
                    }, null, 8, _hoisted_29)
                  ]),
                  _: 1
                }),
                _createVNode(_component_imdex_text_field, {
                  disabled: _ctx.loading,
                  onChange: _ctx.refreshMetadata,
                  error: _ctx.errors.dataStartRow && _ctx.verified,
                  value: _ctx.datastartrow,
                  "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.datastartrow) = $event)),
                  type: "number",
                  label: _ctx.$t(`import.mapping.dataStartsLabel`),
                  min: 2,
                  max: 9999,
                  allowEmpty: true,
                  showNumberIncrement: true,
                  style: {"margin-bottom":"10px"}
                }, null, 8, ["disabled", "onChange", "error", "value", "label"]),
                _createVNode(_component_imdex_tooltip, { nudgeY: -10 }, {
                  activator: _withCtx((on) => [
                    _createElementVNode("div", _mergeProps(_toHandlers(on), { class: "input-info" }), _hoisted_31, 16)
                  ]),
                  tooltip: _withCtx(() => [
                    _createElementVNode("span", {
                      innerHTML: _ctx.$t(`import.mapping.dataStartsTooltip`)
                    }, null, 8, _hoisted_32)
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          (!_ctx.skipMapping)
            ? (_openBlock(), _createElementBlock("span", _hoisted_33, _toDisplayString(_ctx.$t(`import.mapping.mappingTitle`)), 1))
            : _createCommentVNode("", true),
          (!_ctx.loading && !_ctx.skipMapping)
            ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(_ctx.tempMaps[_ctx.activeFile].variableMapping), (item, i) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: i,
                    style: {"display":"flex","align-items":"center","gap":"10px"}
                  }, [
                    _createVNode(_component_imdex_select, {
                      id: `${item}-input`,
                      disabled: _ctx.loading,
                      onChange: 
							($event) => _ctx.updateVariableMapping($event, item)
						,
                      error: _ctx.tempMaps[_ctx.activeFile].variableMapping[item] == '' && _ctx.verified,
                      searchable: "",
                      value: _ctx.tempMaps[_ctx.activeFile].variableMapping[item],
                      "onUpdate:value": ($event: any) => ((_ctx.tempMaps[_ctx.activeFile].variableMapping[item]) = $event),
                      items: _ctx.availableColumns,
                      label: 
							(item == 'hole'
								? _ctx.$t(`import.mapping.${item}`)
								: _ctx.$t(`import.mapping.${item}`)) + ' *'
						
                    }, null, 8, ["id", "disabled", "onChange", "error", "value", "onUpdate:value", "items", "label"]),
                    _createVNode(_component_imdex_tooltip, { nudgeY: -10 }, {
                      activator: _withCtx((on) => [
                        _createElementVNode("div", _mergeProps(_toHandlers(on), { class: "input-info" }), _hoisted_36, 16)
                      ]),
                      tooltip: _withCtx(() => [
                        _createElementVNode("span", {
                          innerHTML: _ctx.generateTooltipContent(item as any)
                        }, null, 8, _hoisted_37)
                      ]),
                      _: 2
                    }, 1024)
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("span", _hoisted_38, _toDisplayString(_ctx.$t(`import.mapping.propertiesTitle`)), 1),
          (!_ctx.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                _createVNode(_component_mapTable, {
                  variableMaps: _ctx.tempMaps[_ctx.activeFile].variableMapping,
                  tableData: _ctx.tempMaps[_ctx.activeFile].tableData,
                  onUpdate: _ctx.updateTableMap
                }, null, 8, ["variableMaps", "tableData", "onUpdate"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                _createVNode(_component_imdex_spinner, {
                  size: 3,
                  width: 50
                })
              ]))
            : _createCommentVNode("", true)
        ], 2))
      : _createCommentVNode("", true),
    (_ctx.showHierarchySelector)
      ? (_openBlock(), _createBlock(_component_HierarchySelector, {
          key: 1,
          holeIdColumn: _ctx.tempMaps[0].variableMapping.hole,
          columns: _ctx.hierarchyCategoricalColumns,
          hierarchySelectedColumns: _ctx.hierarchySelectedColumns,
          "onUpdate:hierarchySelectedColumns": _ctx.updateHierarchySelectedColumns
        }, null, 8, ["holeIdColumn", "columns", "hierarchySelectedColumns", "onUpdate:hierarchySelectedColumns"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_41, [
      _withDirectives(_createVNode(_component_imdex_btn, {
        id: "mapping-prev",
        onClick: _ctx.prev,
        style: {"margin-right":"auto","margin-left":"0"},
        small: "",
        secondary: ""
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t(`import.mapping.prevBtn`)), 1)
        ]),
        _: 1
      }, 8, ["onClick"]), [
        [_vShow, _ctx.activeFile != 0 || _ctx.showHierarchySelector]
      ]),
      _createVNode(_component_imdex_btn, {
        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.cancelDialog = true)),
        disabled: _ctx.creating,
        small: "",
        text: ""
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t(`import.mapping.cancelBtn`)), 1)
        ]),
        _: 1
      }, 8, ["disabled"]),
      (_ctx.activeFile < _ctx.maps.length - 1)
        ? (_openBlock(), _createBlock(_component_imdex_btn, {
            key: 0,
            id: "mapping-next",
            onClick: _ctx.next,
            small: "",
            secondary: ""
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t(`import.mapping.nextBtn`)), 1)
            ]),
            _: 1
          }, 8, ["onClick"]))
        : _createCommentVNode("", true),
      (_ctx.activeFile == _ctx.maps.length - 1)
        ? (_openBlock(), _createBlock(_component_imdex_btn, {
            key: 1,
            id: "mapping-continue",
            onClick: _ctx.finishedMapping,
            loading: _ctx.creating,
            small: "",
            secondary: "",
            disabled: _ctx.noVariablesSelected || _ctx.creating
          }, {
            default: _withCtx(() => [
              (!_ctx.showHierarchySelector && _ctx.type == 'drillhole')
                ? (_openBlock(), _createElementBlock("span", _hoisted_42, _toDisplayString(_ctx.$t(`import.mapping.continueBtn`)), 1))
                : _createCommentVNode("", true),
              (_ctx.showHierarchySelector || _ctx.type != 'drillhole')
                ? (_openBlock(), _createElementBlock("span", _hoisted_43, _toDisplayString(_ctx.$t(`import.mapping.createBtn`)), 1))
                : _createCommentVNode("", true),
              _hoisted_44
            ]),
            _: 1
          }, 8, ["onClick", "loading", "disabled"]))
        : _createCommentVNode("", true)
    ])
  ]))
}